export default () => {
  return { x: 0, y: 0 };
};
